module.exports = __webpack_public_path__ + "img/eye_blue.7828c9a4.svg";